import { connect } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import { LabelMeter } from './index';
import { BatchStatusIdService } from '../batch-status-id-service';

const mapStateToProps = (state, ownProps) => {
  const { batchId } = ownProps;
  const batches = Global.selectBatchesLabelBatchStatusModalLabelBatchStatusModalBatches(state);
  const batch = batches.find((b) => b.batchId === batchId) || {};
  const { statusId } = batch;
  const isGenerating = BatchStatusIdService.isGenerating(statusId);
  const isProcessing = BatchStatusIdService.isProcessing(statusId);
  return {
    processedDate: batch.processDate,
    totalLabels: batch.total,
    successCount: batch.completed,
    warnCount: batch.warnings,
    errorCount: batch.errors,
    isProcessing,
    isGenerating,
  };
};

export const LabelMeterContainer = connect(mapStateToProps)(LabelMeter);
